import React, {
    createContext,
    PropsWithChildren,
    ReactElement,
    useContext
} from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { DEFAULT_SECTIONS_COUNT } from "./constants.ts";
import { PriceCardProps } from "./price-card.tsx";

export interface PriceCardsStackProps extends PropsWithChildren {
    sections?: number;
}

export const PriceCardsStack = (props: PriceCardsStackProps) => {
    const { sections: sectionsCount = DEFAULT_SECTIONS_COUNT } = props;
    const cardsCount = React.Children.count(props.children);
    const children = React.Children.map(props.children, (child, index) => {
        const childElement = child as ReactElement<PriceCardProps>;
        return React.cloneElement(childElement, {
            first: index === 0,
            last: index === cardsCount - 1
        });
    });

    return (
        <PriceCardStackContext.Provider value={{ isInsideCardStack: true }}>
            <div
                css={[
                    priceCardsStackCss,
                    css({
                        gridTemplateRows: `repeat(${sectionsCount}, auto)`,
                        gridTemplateColumns: `repeat(${cardsCount}, minmax(0, 384px))`
                    })
                ]}
            >
                {children}
            </div>
        </PriceCardStackContext.Provider>
    );
};

const priceCardsStackCss = css({
    display: "grid",
    gridAutoFlow: "column",
    width: "fit-content",
    [media.above.md]: {
        width: "fit-content"
    },
    [media.below.md]: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
    }
});

interface PriceCardStackContextValue {
    isInsideCardStack: boolean;
}
const PriceCardStackContext = createContext<PriceCardStackContextValue>({
    isInsideCardStack: false
});

export const useIsInsideCardStack = () => {
    return useContext(PriceCardStackContext);
};
